module.exports = __webpack_public_path__ + "media/images/home/teaching_resources_icon-b42afdd848c39ba813e321d2f1cbae32.svg";